//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
SPLM.AME.EplanPropertyType = Object.freeze({
    "FunctionalAssignment" : "FunctionalAssignment", "HigherLevelFunction" : "HigherLevelFunction", "InstallationSite" : "InstallationSite", "MountingLocation" : "MountingLocation", "DocumentType" : "DocumentType", "UserDefinedStructure" : "UserDefinedStructure", "Max" : "Max"});

export default SPLM;